<div class="content-container" #printableDoc>
    <h1 class="text-left ">Pacient:</h1>
       <table>
           <tr class="text-left">
               <th>Nume</th>
               <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_numePacient)}}</td>
           </tr>
           <tr class="text-left">
               <th>Prenume</th>
               <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_prenumePacient)}}</td>
           </tr>
           <tr class="text-left">
               <th>Adresa</th>
               <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_addrPacient)}}</td>
           </tr>
           <tr class="text-left">
               <th>CNP</th>
               <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_cnpPacient)}}</td>
           </tr>
           <tr class="text-left">
               <th>Data nastere:</th>
               <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_dateOfBirthPacient)}}</td>
           </tr>
           <tr class="text-left">
               <th>Gen:</th>
               <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_sex) | transloco}}</td>
           </tr>
           <tr class="text-left">
               <th>Nr. tel:</th>
               <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_phone)}}</td>
           </tr>
           <tr class="text-left">
               <th>Email:</th>
               <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_email)}}</td>
           </tr>

       </table>
    <ng-container *ngIf="hasLegalRep()">
        <h1 class="text-left mt-4">Reprezentant legal:</h1>
        <table>
            <tr class="text-left">
                <th>Nume</th>
                <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_numeLegalPers)}}</td>
            </tr>
            <tr class="text-left">
                <th>Prenume</th>
                <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_prenumeLegalPers)}}</td>
            </tr>
            <tr class="text-left">
                <th>Adresa</th>
                <td>{{getValueOfFieldWithName(docFields,BasicInfoFieldNames.basic_addrLegalPers)}}</td>
            </tr>
        </table>
    </ng-container>


<!--    basic_flowStatusField = "basic_flowStatusField",-->
<!--    basic_tipPersoana = "basic_tipPersoana",-->
<!--    basic_prenumePacient = "basic_prenumePacient",-->
<!--    basic_numePacient = "basic_numePacient",-->
<!--    basic_addrPacient = "basic_addrPacient",-->
<!--    basic_dateOfBirthPacient = "basic_dateOfBirthPacient",-->
<!--    basic_cnpPacient = "basic_cnpPacient",-->
<!--    basic_prenumeLegalPers = "basic_prenumeLegalPers",-->
<!--    basic_numeLegalPers = "basic_numeLegalPers",-->
<!--    basic_addrLegalPers = "basic_addrLegalPers",    -->

</div>
